import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link"
import {InductAreaContext} from "./context/InductAreaContext";
import {FormattedMessage} from "react-intl";
import {EMPTY_STRING, TOTAL_STRING} from "../util/Constants";
import {getRefreshInterval} from "../util/Util";
import RefreshTimer from "../util/RefreshTimer";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const InductArea = () => {
    const {viewModel, dispatch} = useContext(InductAreaContext)
    const {isMobile} = useDeviceLayout();

    const getDataForInductArea = () => {
        dispatch({type: 'LOAD_VIEW', data:{dispatcher: dispatch}});
    }

    const isASLInductLocation = (locationName) => {
        return locationName.startsWith('ASL')
    }

    const isInductTypeColumnRequired = viewModel.inductAreaData
        .map(inductAreaInsight => inductAreaInsight.locationName)
        .filter(locationName => isASLInductLocation(locationName)).length > 0

    const getInductType = (locationName) => {
        return isASLInductLocation(locationName) ? getAutomationInductType() :
            <FormattedMessage id="induct.manual" defaultMessage="Manual"/>;
    }

    const getAutomationInductType = () => {
        const formattedMessage = <FormattedMessage id ="induct.automated" defaultMessage="Automated"/>
        return <Link href="#/aslInduct" type="secondary">{formattedMessage}</Link>
    }

    useEffect(() => {
        getDataForInductArea()
        const interval = setInterval(() => {
            if (!document.hidden) {
                getDataForInductArea();
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    },[])

    return (
        <div>
            <Row width="100%" widths={isMobile ? ["grid-12"] : ["grid-8"]}>
                <div>
                    <RefreshTimer deps={[viewModel]}/>
                    <Row width="100%" widths={["grid-3","grid-3","grid-3", "grid-3", "grid-3"]} spacingInset="medium none none">
                        <Text/>
                        {isInductTypeColumnRequired && <Text type="h100">
                            <FormattedMessage id="induct.induct_type" defaultMessage="Induct Type"/> </Text>}
                        <Text type="h100" alignment="right">
                            <FormattedMessage id="induct.active_associate" defaultMessage="Active associates"/>
                        </Text>
                        <Text type="h100" alignment="right">
                            <FormattedMessage id="induct.induct_rate" defaultMessage="Induct rate"/>
                        </Text>
                        <Text type="h100" alignment="right">
                            <FormattedMessage id="induct.total_inducted" defaultMessage="Total Inducted"/>
                        </Text>
                    </Row>
                    {viewModel.inductAreaData.map((inductAreaInsight) => (
                        <Row key={inductAreaInsight.locationName} width="100%" widths={["grid-3", "grid-3", "grid-3", "grid-3", "grid-3"]}
                             spacingInset="medium none none">
                            <Text type="h100">{inductAreaInsight.locationName}</Text>
                            { isInductTypeColumnRequired && <Text> {inductAreaInsight.locationName === TOTAL_STRING
                                ? EMPTY_STRING : getInductType(inductAreaInsight.locationName)}</Text>}
                            <Text alignment="right">
                                {inductAreaInsight.operatorCount > 0 ?
                                    <Link href="#/associate" type="secondary">{inductAreaInsight.operatorCount}</Link>
                                    : inductAreaInsight.operatorCount}
                            </Text>
                            <Text alignment="right">{inductAreaInsight.inductRate}</Text>
                            <Text alignment="right">{inductAreaInsight.volumeInducted}</Text>
                        </Row>
                    ))}
                </div>
            </Row>
        </div>
    )
}

export default InductArea


// WEBPACK FOOTER //
// ./src/components/induct/InductArea.js